// extracted by mini-css-extract-plugin
module.exports = {"content":"_02712f2b3b--content--_Bi5x","icon-wrapper":"_02712f2b3b--icon-wrapper--Unje4","heading":"_02712f2b3b--heading--IqiYP","footer":"_02712f2b3b--footer--M5UrR"};